<script lang="ts">
	import { onMount } from "svelte"
	import GroupCanvas from "../../canvas/GroupCanvas.svelte"
	import { GroupEditorController } from "../../GroupEditorController"
	import { GroupOverlapController } from "./GroupOverlapController"
	import type { DeviceGroupSlot } from "luxedo-data"

	let slots: Array<DeviceGroupSlot> = $state([])
	let overlapInstances: Array<GroupOverlapController.OverlapInstance> = $state([])

	GroupEditorController.Slots.subscribe((ctx) => {
		slots = ctx.slots
	})

	GroupOverlapController.subscribe((ctx) => {
		overlapInstances = ctx.overlapInstances
	})

	function overlapClick(overlapID: string) {
		GroupOverlapController.selectOverlap(overlapID)
	}

	onMount(() => GroupEditorController.Slots.selectSlot(undefined))
</script>

<GroupCanvas {slots} slotOverlaps={overlapInstances} onOverlapClick={overlapClick} />

<style>
</style>
